import { Table } from 'antd';
const HIGHLIGHTED = '$$_highlighted';

export default {
    DefaultTable: class extends React.Component {
        constructor(props) { super(props); }
        render() {
            const { columns, dataSource } = this.props;
            return <Table
                bordered
                {...this.props}
                dataSource={(() => dataSource == null || dataSource.length === 0 ? []
                    : dataSource.map((e, i) => (i + 1)%2 !== 0
                        ? {...e, [HIGHLIGHTED]: false }
                        : {...e, [HIGHLIGHTED]: true }
                    ))()
                }
                style={{ wordBreak: 'normal',  }}
                columns={columns}
                components={{
                    header: {
                        cell: ({ children, ...props }) => (
                            <th {...props}>
                                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    {children}
                                </div>
                            </th>
                        )
                    },
                    body: {
                        row: ({ children, ...props }) => (
                            <tr
                                {...props}
                                style={!children[0].props.record[HIGHLIGHTED] ? {backgroundColor: '#ead1c2', fontSize:'13px'} : { backgroundColor: '#bebebe', fontSize:'13px' }}
                            >
                                {children}
                            </tr>
                        )
                    }
                }}
            />;
        }
    }
}
